module.exports = {"id":"dp2_2l1q3","text":"Sharing Through Digital Technologies","instructions":"Sharing information online can involve both benefits and risks.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.2","questionType":"PickOne","random":false,"options":[{"id":"dp2_2l1q3-a1","text":"True","score":1.8},{"id":"dp2_2l1q3-a2","text":"Not sure","score":0},{"id":"dp2_2l1q3-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l1q3.json
// module id = 1012
// module chunks = 41